import { Component, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslocoDirective} from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class ToastService {
  public message: string | null = null;
  public error: string | null = null;
  public type: 'error' | 'success' = 'error';
  public show(
    message: string,
    type: 'error' | 'success' = 'error',
    duration = 3000
  ) {
    // Show both error and success toasts
    this.message = message;
    this.type = type;
    setTimeout(() => (this.message = null), duration);
  }
  public close() {
    this.message = null;
  }
}

@Component({
  selector: 'app-mb-toast',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  template: `
    <div *ngIf="toastService.message" class="mb-toast" [ngClass]="'mb-toast-' + toastService.type">
      <div class="flex justify-between px-6 py-2 rounded-lg bg-white">
        <div class="mb-toast-icon">
          <!-- Error Icon -->
          <svg
            *ngIf="toastService.type === 'error'"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="text-red-500"
          >
            <rect width="32" height="32" rx="8" fill="#FEE2E2" />
            <path
              d="M20.2426 11.7574L11.7574 20.2426"
              stroke="#EF4444"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M11.7574 11.7574L20.2426 20.2426"
              stroke="#EF4444"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <!-- Success Icon -->
          <svg
            *ngIf="toastService.type === 'success'"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="text-green-500"
          >
            <rect width="32" height="32" rx="8" fill="#DCFCE7" />
            <path
              d="M13.5 16.5L15.5 18.5L18.5 13.5"
              stroke="#22C55E"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div class="mb-toast-text flex-1 mx-3" *transloco="let t">
          <div class="mb-toast-title" [ngClass]="toastService.type === 'error' ? 'text-red-600' : 'text-green-600'">
            {{ toastService.type === 'error' ? t('toast.error') : t('toast.success')  }}
          </div>
          <div class="mb-toast-message text-gray-800">
            {{ toastService.message }}
          </div>
        </div>
        <button
          class="mb-toast-close"
          (click)="toastService.close()"
          aria-label="Close"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L4 12"
              stroke="#9CA3AF"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M4 4L12 12"
              stroke="#9CA3AF"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .mb-toast {
        position: fixed;
        bottom: 32px;
        left: 50%;
        transform: translateX(-50%);
        color: #111827;
        padding: 0;
        z-index: 1001;
        min-width: 340px;
        max-width: 90vw;
        animation: fadein 0.3s, fadeout 0.3s 2.7s;
      }

      .mb-toast-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .mb-toast-title {
        font-weight: 700;
        font-size: 1rem;
        margin-bottom: 2px;
      }

      .mb-toast-message {
        font-size: 0.95rem;
        color: #111827;
      }

      .mb-toast-close {
        background: white;
        border: none;
        cursor: pointer;
        padding: 4px;
        margin-left: 12px;
        border-radius: 4px;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      @keyframes fadein {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes fadeout {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }
    `,
  ],
})
export class MbToastComponent {
  constructor(public toastService: ToastService) {}
}
